import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import BookListItemEmpty from 'rebook/apps/books/components/BookListItemEmpty';
import BookCardHeader from 'rebook/apps/base/components/BookCardHeader';
import BookReviewCitationHeader from 'rebook/apps/books/components/BookReviewCitationHeader';
import * as BookCitationPageAction from 'rebook/apps/books/actions/BookCitationPageAction';
import { Book } from 'rebook/apps/books/models';
import BookCitation from 'rebook/apps/books/components/BookCitation';

import styles from './style.scss';


class BookCitationPageView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.BookCitationPageAction.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.BookCitationPageAction.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(BookCitationPageAction.fetchInitialData(match));
  }

  render() {
    const { user } = this.props;
    const { citation } = this.props.bookCitation;
    const theBook = citation && new Book(citation.book);
    const titleText = citation && citation.my_citation ? `Моя цитата` : `Цитата из книги`;

    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className={classNames('section')}>
          {theBook && (
            <React.Fragment>
              <BookReviewCitationHeader
                title={titleText}
                isCitation
                bookName={theBook.name}
                link={theBook.getLink()} />
              <BookCardHeader withAuthor book={theBook} user={user} withButton GACategory="BookQuote" />
            </React.Fragment>
          )}
          {citation === null
            ? <BookListItemEmpty />
            : (
              <div className={styles.citation}>
                <BookCitation citation={citation} noTruncate isDetailPage />
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookCitation: state.bookCitation,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookCitationPageAction: bindActionCreators(BookCitationPageAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookCitationPageView);
